import type { Facet } from "../types";

const keyOf = (f: Pick<Facet, "name" | "value">) => `${f.name}:${f.value}`;

// Quanto maior, melhor representante do par: cadastro manual (sem `source`) vem
// antes do registrado por skill, e linha com rótulo antes da sem rótulo.
const rank = (f: Facet) => (f.source ? 0 : 2) + (f.labels ? 1 : 0);

/**
 * O vocabulário de facetas para ESCOLHER — um item por `name:value`.
 *
 * `organization_facets` guarda uma linha por origem: cada skill instalada
 * registra as próprias etiquetas (`source='skill'`, `source_id` = skill), para a
 * desinstalação levar só as dela. A mesma faceta aparece então uma vez por skill
 * que a declara. O filtro casa por `name:value`, então para quem escolhe isso é
 * repetição pura. Quem administra o cadastro (Configurações) segue vendo as
 * linhas cruas.
 *
 * `parent_facet_id` que apontava para uma linha descartada é redirecionado para
 * a que ficou com o mesmo par, para a árvore não perder o pai.
 */
export function distinctFacets(facets: Facet[]): Facet[] {
  const chosen = new Map<string, Facet>();
  for (const f of facets) {
    const current = chosen.get(keyOf(f));
    if (!current || rank(f) > rank(current)) chosen.set(keyOf(f), f);
  }

  const byId = new Map(facets.map((f) => [f.id, f]));
  const keptIdFor = (id: string | null) => {
    if (!id) return null;
    const parent = byId.get(id);
    return parent ? (chosen.get(keyOf(parent))?.id ?? id) : id;
  };

  return facets
    .filter((f) => chosen.get(keyOf(f)) === f)
    .map((f) => {
      const parentId = keptIdFor(f.parent_facet_id);
      return parentId === f.parent_facet_id ? f : { ...f, parent_facet_id: parentId };
    });
}
